import React from 'react';

import {Link} from 'react-router';

import {UserAvatar} from 'app/components/general/avatars';
import {getUserDetailPageURL} from 'app/urls';
import {printContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {DateText, FixableHeader, FixableTable} from './utils';

import {
  BasicRoleSerializedType,
  BasicTeamSerializedType,
  BasicUserSerializedType,
  ContentType,
  ReportResultSerializedType,
} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<{
    html_url: string;
    name: string;
    url: string;
    content_type: ContentType;
    timestamp: string;
    assigner: BasicUserSerializedType;
    users: Array<BasicUserSerializedType>;
    teams: Array<BasicTeamSerializedType>;
    roles: Array<BasicRoleSerializedType>;
    revoked_at: string;
    repetition: string;
  }>;
}

export function RenderTasksAssignedSummary({result}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Document type')}</FixableHeader>
          <FixableHeader>{gt('Assigned At')}</FixableHeader>
          <FixableHeader>{gt('Assigner')}</FixableHeader>
          <FixableHeader>{gt('Assigned Members')}</FixableHeader>
          <FixableHeader>{gt('Assigned Teams')}</FixableHeader>
          <FixableHeader>{gt('Assigned Roles')}</FixableHeader>
          <FixableHeader>{gt('Permissions Revoked At')}</FixableHeader>
          <FixableHeader>{gt('Repetition')}</FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <Link className="font-weight-bold" to={r.html_url}>
                {r['name']}
              </Link>
            </td>
            <td>{printContentType(r['content_type'])}</td>
            <td>
              <DateText>{r['timestamp']}</DateText>
            </td>
            <td>
              <div className="d-flex align-items-center">
                <UserAvatar user={r.assigner} small showCard className="mr-1" />
                <Link to={getUserDetailPageURL(r.assigner.id)}>
                  {r.assigner.name}
                </Link>
              </div>
            </td>
            <td>
              <ul className="mb-0 pl-4">
                {r.users.map((t) => (
                  <div key={t.url} className="d-flex align-items-center">
                    <UserAvatar user={t} small showCard className="mr-1" />
                    <Link to={getUserDetailPageURL(t.id)}>{t.name}</Link>
                  </div>
                ))}
              </ul>
            </td>
            <td>
              <ul className="mb-0 pl-4">
                {r.teams.map((t) => (
                  <li key={t.html_url}>
                    <Link to={t.html_url}>{t.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td>
              <ul className="mb-0 pl-4">
                {r.roles.map((t) => (
                  <li key={t.html_url}>
                    <Link to={t.html_url}>{t.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td>
              <DateText>{r.revoked_at}</DateText>
            </td>
            <td>{r.repetition}</td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
